import { useGoTo } from "@/lib/useGoTo";
import { Reveal } from "./Reveal";

// Shared page hero band for routed pages (About, FAQ, Stores).
export const PageHero = ({ overline, title, accent, children }) => (
  <div className="bg-[#0b0b0c] pt-36 pb-16 lg:pb-20">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline-label mb-5">{overline}</p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-medium text-[#faf8f5] leading-[1.08] tracking-tight">
          {title} {accent && <em className="font-accent text-[#dfcca4]">{accent}</em>}
        </h1>
        {children}
      </Reveal>
    </div>
  </div>
);

export const BookCta = ({ testId = "page-book-cta" }) => {
  const goTo = useGoTo();
  return (
    <button
      data-testid={testId}
      onClick={() => goTo({ type: "anchor", id: "book" })}
      className="px-8 py-3.5 bg-[#c5a059] text-[#0b0b0c] font-mono-ov text-xs tracking-[0.18em] uppercase rounded-full hover:bg-[#dfcca4] hover:scale-[1.03] transition-all duration-300"
    >
      Book a Consultation
    </button>
  );
};
